/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import ITipoRegimen from './entidades/tipoRegimen';

export default class ModeloTipoRegimen {
    public consultarTipoRegimen() {
        return manejadorRest<IRespuesta<ITipoRegimen>>(() =>
            seguridad.get('TipoRegimen/ConsultarListaTipoRegimen')
        );
    }
    public crearTipoRegimen(tipoRegimen: ITipoRegimen) {
        return manejadorRest<IRespuesta<ITipoRegimen>>(() =>
            seguridad.post('TipoRegimen/GuardarTipoRegimen', tipoRegimen)
        );
    }
    public editarTipoRegimen(tipoRegimen: ITipoRegimen) {
        return manejadorRest<IRespuesta<ITipoRegimen>>(() =>
            seguridad.put('TipoRegimen/EditarTipoRegimen', tipoRegimen)
        );
    }
    public eliminarTipoRegimen(tipoRegimen: ITipoRegimen) {
        return manejadorRest<IRespuesta<ITipoRegimen>>(() =>
            seguridad.delete('TipoRegimen/EliminarTipoRegimen', tipoRegimen)
        );
    }
}
